// extracted by mini-css-extract-plugin
module.exports = {"Affix":"BottomAffix_Affix__1H1H5"};